import axios from "axios";
export const userExist = (email) => {
  return axios
    .post(`${process.env.REACT_APP_ANTIAGING_API}api/emailexists`, { email })
    .then(({ data }) => data.is_registered)
    .catch(console.error);
};
